(function () {
    function setTopbarDropdownOpen($dropdown, open) {
        const $menu = $dropdown.find('.dropdown-menu');
        const $toggle = $dropdown.find('.dropdown-toggle');
        if (open) {
            $dropdown.addClass('show');
            $menu.addClass('show');
            $toggle.attr('aria-expanded', 'true');
            return;
        }
        $dropdown.removeClass('show');
        $menu.removeClass('show');
        $toggle.attr('aria-expanded', 'false');
    }

    function runLogoutAction($root) {
        const modalTarget = String($root.data('logout-modal-target') || '').trim();
        const callbackName = String($root.data('logout-callback') || '').trim();
        if (modalTarget !== '' && typeof $ === 'function' && $(modalTarget).length) {
            $(modalTarget).modal('show');
            return;
        }
        const callbackFn = callbackName !== '' ? window[callbackName] : null;
        if (typeof callbackFn === 'function') {
            callbackFn();
        }
    }

    function runTopbarAction(actionName) {
        switch (actionName) {
            case 'member-login':
                if (typeof window.MemberLoginPage === 'function') {
                    window.MemberLoginPage();
                }
                break;
            case 'member-register':
                if (typeof window.MemberRegisterPage === 'function') {
                    window.MemberRegisterPage();
                }
                break;
        }
    }

    function initTopbarAccountMenus() {
        const $roots = $('.topbar-account-menu');
        if (!$roots.length) {
            return;
        }

        $roots.each(function () {
            const $root = $(this);
            const $toggle = $root.find('.dropdown-toggle');
            const $menu = $root.find('.dropdown-menu');

            $toggle.off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
                event.preventDefault();
                event.stopPropagation();
                const isOpen = $root.hasClass('show');
                $('.topbar-account-menu').each(function () {
                    setTopbarDropdownOpen($(this), false);
                });
                setTopbarDropdownOpen($root, !isOpen);
            });

            $menu.off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
                event.stopPropagation();
            });

            $menu.find('[data-logout-trigger]').off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
                event.preventDefault();
                setTopbarDropdownOpen($root, false);
                runLogoutAction($root);
            });

            $menu.find('.dropdown-item').off('click.topbarAccountMenuClose').on('click.topbarAccountMenuClose', function () {
                setTopbarDropdownOpen($root, false);
            });

            $menu.find('.dropdown-item[data-topbar-action]').off('click.topbarAccountMenuAction').on('click.topbarAccountMenuAction', function (event) {
                event.preventDefault();
                runTopbarAction(String($(this).data('topbar-action') || ''));
            });

            $menu.find('.dropdown-item[data-onclick]').off('click.topbarAccountMenuOnclick').on('click.topbarAccountMenuOnclick', function (event) {
                event.preventDefault();
                window.runNamedCallback($(this).data('onclick'), event);
            });

            $menu.find('[data-role-switch-url]').off('click.topbarAccountMenuRoleSwitch').on('click.topbarAccountMenuRoleSwitch', function (event) {
                event.preventDefault();
                const $item = $(this);
                $('#overlay').first().fadeIn();
                window.submitPostForm(String($item.data('role-switch-url') || ''), String($item.data('csrf-token') || ''));
            });
        });

        $(document).off('click.topbarAccountMenu').on('click.topbarAccountMenu', function (event) {
            if ($(event.target).closest('.topbar-account-menu').length) {
                return;
            }
            $('.topbar-account-menu').each(function () {
                setTopbarDropdownOpen($(this), false);
            });
        });
    }

    window.initTopbarAccountMenus = initTopbarAccountMenus;
    $(document).ready(initTopbarAccountMenus);
})();
